import RequestsPopup from './RequestsPopup';
// Styles
import './style.scss';
import { theme } from 'src/theme';

export * from './RequestsPopup';

if (theme.mode === 'dark') {
  import(/* webpackChunkName: "dark" */ './style.scss?dark');
}

export default RequestsPopup;